import React, {Component} from 'react';
import axios from 'axios';
import './Wallet.css';
import Breadcrumbs from '../Components/Breadcrumbs';
class Wallet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menu : [],
            modal: false
    
        }
    }
    
  render() {
    return <div>
        <div class="container">
            {/* <nav aria-label="breadcrumb">
            <ol class="breadcrumb2 breadcrumb brdcum">
                <li class="breadcrumb"><a href="index.html"> Home&nbsp; </a></li>
                <li class="breadcrumb"> / My Wallet</li>
            </ol>
            </nav> */}
            <div class="row">
            <Breadcrumbs title="My Wallet" bc="My Wallet"/>
                <div class="col-md-4 mt-3">
                    <h2>Wallet</h2>
                </div>
                <div class=" col-md-5 mt-4">
                        <p class="manage">You can manage and set your profile information here</p>
                        
                        <h3>Add Money to Wallet</h3>
                        <div class="row-form mt-2">
                        <input class="form-controls" type="text" placeholder="Enter Amount" id="example-email-input"/>
                        </div>  
                        <div class="tag_bottom">
                            <button type="button" class=" add-to-select btn-width btn-outline-success waves-effect waves-light tag-btn"><u>₹100</u></button>
                            <button type="button" class=" add-to-select btn-width btn-outline-success waves-effect waves-light tag-btn"><u>₹500</u></button>
                            <button type="button" class=" add-to-select btn-width btn-outline-success waves-effect waves-light tag-btn"><u>₹1000</u></button>
                        </div>
                        <a href="#"><button type="button" class=" add-to-cart2 btnn mt-31" onClick={e => this.modalOpen(e)}>Next</button></a>
                                   {/*  <Modal
                                        size="lg"
                                        isOpen={this.state.modal}
                                        
                                        show={this.state.modal}
                                       
                                    >
                            
                            <ModalHeader toggle={() => this.setState({ modal: false })}>
                            </ModalHeader>
                            <ModalBody>
                                    <Makepayment />

                            </ModalBody>
                          
                            </Modal> */}
                        <br/>
                        <br/>
                        <br/>
                        <h3> Wallet Options</h3>
                        
                        <p className="green-link my-link mb-5 mt-2"><a href="/wallet-transfer">Show All Transaction History </a></p>
                    
                </div>
                <div class=" col-md-3 wallet-balance"> 
                <span className="price">Current Wallet Balance<p>Rs&nbsp;150</p></span>
                </div>
                </div>
    </div>
</div>

    }
}
export default Wallet;